/*
 * Product slider — arrows + snap scrolling for any product grid marked
 * with .custom-slider (set by the "Show as slider" section setting).
 *
 * Product recommendations and recently viewed both inject their <li> items
 * after the section renders, so the track is watched and set up again
 * whenever its contents change.
 */
(function () {
  var ARROW = {
    prev: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6"/></svg>',
    next: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg>'
  };

  function track(root) {
    return root.querySelector('.products.collection.row');
  }

  function makeButton(root, dir, label) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'custom-slider__nav custom-slider__nav--' + dir;
    btn.setAttribute('aria-label', label);
    btn.innerHTML = ARROW[dir];
    btn.addEventListener('click', function () {
      var el = track(root);
      if (!el) return;
      var first = el.querySelector('.columns');
      // move by whole cards, a full viewport of them at a time
      var step = first ? first.getBoundingClientRect().width : el.clientWidth;
      var perView = Math.max(1, Math.round(el.clientWidth / step));
      root.classList.add('is-scrolling');
      el.scrollBy({ left: (dir === 'next' ? 1 : -1) * step * perView, behavior: 'smooth' });
      setTimeout(function () {
        root.classList.remove('is-scrolling');
      }, 450);
    });
    root.appendChild(btn);
    return btn;
  }

  function refresh(root) {
    var el = track(root);
    if (!el) return;
    // 2px of slack so a sub-pixel rounding doesn't leave the arrows on
    var overflows = el.scrollWidth - el.clientWidth > 2;
    root.classList.toggle('has-overflow', overflows);
    if (!overflows) return;

    var atStart = el.scrollLeft <= 2;
    var atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 2;
    if (root.__prev) root.__prev.disabled = atStart;
    if (root.__next) root.__next.disabled = atEnd;
  }

  function setup(root) {
    var el = track(root);
    if (!el) return;

    if (!root.__prev) {
      root.__prev = makeButton(root, 'prev', 'Previous products');
      root.__next = makeButton(root, 'next', 'Next products');
      el.addEventListener('scroll', function () {
        window.requestAnimationFrame(function () {
          refresh(root);
        });
      }, { passive: true });
    }
    refresh(root);
  }

  function init() {
    document.querySelectorAll('.custom-slider').forEach(function (root) {
      setup(root);

      // the items arrive after a fetch, so re-measure when they land
      new MutationObserver(function () {
        setup(root);
      }).observe(root, { childList: true, subtree: true });
    });

    window.addEventListener('resize', function () {
      document.querySelectorAll('.custom-slider').forEach(refresh);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // the theme editor re-renders sections in place
  document.addEventListener('shopify:section:load', init);
})();
